// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__gPBb7","title":"Info_title__1LDmh","selects":"Info_selects__1Qbq_","requiredAsterisk":"Info_requiredAsterisk__1Of-z"};